import { ReactNode } from "react";
import { Text } from "@/components/Typography";

interface ProfileFieldProps {
  icon: ReactNode;
  label: string;
  value: ReactNode;
  isEditing?: boolean;
  editContent?: ReactNode;
  iconBackground?: boolean;
}

export const ProfileField = ({
  icon,
  label,
  value,
  isEditing = false,
  editContent,
  iconBackground = true,
}: ProfileFieldProps) => {
  return (
    <div className="flex items-center gap-3">
      <div
        className="flex flex-shrink-0 items-center justify-center"
        style={{
          width: "var(--profile-icon-size)",
          height: "var(--profile-icon-size)",
          borderRadius: "var(--profile-icon-radius)",
          backgroundColor: iconBackground ? "var(--color-profile-icon-chip-bg)" : "transparent",
        }}
        aria-hidden="true"
      >
        {icon}
      </div>

      <div className="min-w-0 flex-1 space-y-0.5">
        <Text
          as="p"
          className="font-instrument font-normal text-theme-text-muted truncate mb-1.5"
          style={{
            fontSize: "var(--profile-info-title-font-size)",
            lineHeight: "var(--profile-info-title-line-height)",
          }}
        >
          {label}
        </Text>

        {isEditing ? (
          editContent || null
        ) : (
          <div className="min-w-0" title={typeof value === "string" ? value || "Add details" : undefined}>
            {typeof value === "string" ? (
              <Text
                as="p"
                className="font-inter font-medium text-theme-text-heading truncate"
                // Line height set with the size: Radix Text's default (~16px)
                // is shorter than this font, and `truncate` hides the overflow,
                // so descenders (g, y, p) were being clipped.
                style={{
                  fontSize: "var(--profile-info-value-font-size)",
                  lineHeight: "var(--profile-info-value-line-height)",
                }}
              >
                {value || (
                  <Text as="span" className="text-theme-text-muted italic">
                    Add details
                  </Text>
                )}
              </Text>
            ) : (
              value
            )}
          </div>
        )}
      </div>
    </div>
  );
};
